import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Inject, OnDestroy, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { AbstractControl, FormArray, FormBuilder, FormGroup, NgForm, ValidationErrors, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTabGroup } from '@angular/material/tabs';
import { DialogService } from 'src/app/services/dialog.service';
import { DrupalRESTService } from 'src/app/services/drupal-rest.service';
import { EntityRESTService } from 'src/app/services/entity-rest.service';
import { FieldsService } from 'src/app/services/fields.service';
import { TaxonomyService } from 'src/app/services/taxonomy.service';
import { UtilityService } from 'src/app/services/utility.service';
import { BaseComponent } from '../base-form/base-form.component';
import _, { split } from 'lodash';
import moment from 'moment';
import 'moment-timezone';
import { computeIsEventPassed } from './event-passed.util';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthRESTService } from 'src/app/services/auth-rest.service';
import { AuthService } from 'src/app/services/auth.service';
import { MenuRESTService } from 'src/app/services/menu-rest.service';
import { ComponentType } from '@angular/cdk/overlay';
import { RouteEventsService } from 'src/app/route-events.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { ConfigPagesService } from 'src/app/services/config-pages.service';
import { PackagesService } from 'src/app/services/packages.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserService } from 'src/app/services/user.service';
import { DomSanitizer } from '@angular/platform-browser';
import { RefreshService } from 'src/app/services/refresh.service';
import { StudioConfigService } from 'src/app/services/studio-config.service';
import { ComponentRefreshService } from 'src/app/services/component-refresh.service';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';
import { CountryCode, E164Number } from 'libphonenumber-js';
import { PhoneNumberService, PhoneValidationResult } from 'src/app/services/phone-number.service';
import { LoggerService } from '../../../services/logger.service';
@Component({
  selector: 'app-base-dialog',
  template: '',
})
export class BaseDialogComponent extends BaseComponent implements OnInit, OnDestroy {

  constructor(
    public _dialogRef: MatDialogRef<unknown>,
    public _dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public _injectedDialogData: any,
    public override _refreshService: RefreshService,
    public override _dialogService: DialogService,
    public override _entityRESTService: EntityRESTService,
    public override _utilityService: UtilityService,
    public override _fieldsService: FieldsService,
    public override _drupalRESTService: DrupalRESTService,
    public override _taxonomyService: TaxonomyService,
    public override _router: Router,
    public override _activatedRoute: ActivatedRoute,
    public override _authRESTService: AuthRESTService,
    public override _authService: AuthService,
    public override _menuRESTService: MenuRESTService,
    public override _formBuilder: FormBuilder,
    public override _routeEventsService: RouteEventsService,
    public override _permissionsService: PermissionsService,
    public override _renderer2: Renderer2,
    public override _configPages: ConfigPagesService,
    public override _packagesService: PackagesService,
    public override _snackBar: MatSnackBar,
    public override _userRESTService: UserService,
    public override _el: ElementRef,
    public override _changeDetectorRef: ChangeDetectorRef,
    public override _sanitizer: DomSanitizer,
    public override _studioConfigService: StudioConfigService,
    public override _componentRefreshService: ComponentRefreshService,
    public override _translateService: TranslateService,
    public phoneNumberService: PhoneNumberService
  ) {
    super(
      _refreshService,
      _dialogService,
      _entityRESTService,
      _utilityService,
      _fieldsService,
      _drupalRESTService,
      _taxonomyService,
      _router,
      _activatedRoute,
      _authRESTService,
      _authService,
      _menuRESTService,
      _formBuilder,
      _routeEventsService,
      _permissionsService,
      _renderer2,
      _configPages,
      _packagesService,
      _snackBar,
      _userRESTService,
      _el,
      _changeDetectorRef,
      _sanitizer,
      _studioConfigService,
      _componentRefreshService,
      _translateService
    );
  }

  @ViewChild('attendee') ngModelGroup: any;
  injectedDialogData = this._injectedDialogData;
  __field_students_inline_form: any;
  enrollmentMessage: any;
  _enrollmentEntityData: any;
  eckType: string = "";
  bundle: string = "";
  entityId: number = this._injectedDialogData?.['data']?.['EntityID'];
  paymentID: any;
  paymentSaleDate;
  payment_methods: any;
  square_payment_methods: any;
  paybright_payment_methods: any;
  paybright_bank_accounts: any[] = [];
  isEventPassed: boolean;
  studioTimezone: string = '';
  enrollmentTouched: boolean | number = false; // New property to track if enrollment amount has been touched
  isSaving: boolean = false; // Flag to prevent multiple saves
  // Shown when a request gets no response (status 0). A dialog can swap in a
  // more specific message before handleError runs.
  noResponseMessage: string = "Couldn't reach the server, so this may not have saved. Check whether it shows up before entering it again.";

  ngOnInit(): void {
    let action = this._injectedDialogData?.['data']?.['action'];

    if (action) {
      this.initActionType = this._injectedDialogData['data']['action'];
      this.actionType = this._injectedDialogData['data']['action'];
    }

    LoggerService.log('this._injectedDialogData', this._injectedDialogData);
    this.studioConfigSubscription = this._studioConfigService.getStudioConfig().subscribe(config => {
      this.studioTimezone = config?.['field_studio_timezone']?.[0]?.value || '';
      this.checkIfEventPassedCurrentTime();
    });
    this.checkIfEventPassedCurrentTime();
  }

  // getStudioConfig() is app-lifetime; left open it keeps every closed dialog in memory.
  private studioConfigSubscription: Subscription;

  ngOnDestroy(): void {
    this.studioConfigSubscription?.unsubscribe();
  }

  init() {
    let action = this._injectedDialogData?.['data']?.['action'];

    if (action) {
      this.initActionType = this._injectedDialogData['data']['action'];
      this.actionType = this._injectedDialogData['data']['action'];
    }

    // LoggerService.log('this._injectedDialogData', this._injectedDialogData);
  }

  override ngAfterContentInit(): void {
    let action = this._injectedDialogData?.['data']?.['action'];
    LoggerService.log('ACTION: ', action)
    if (action) {
      if (this._injectedDialogData['data']['action'] == 'view' || this._injectedDialogData['data']['action'] == 0) {
        this.getEntity(this._injectedDialogData['data']['eckType'], this._injectedDialogData['data']['bundle'], this._injectedDialogData['data']['EntityID']);
        this.setFormMode("view");
      }

      if (this._injectedDialogData['data']['action'] == 'create') {
        this.setFormMode("create");
      }

      if (this._injectedDialogData['data']['action'] == 'edit') {
        this.getEntity(this._injectedDialogData['data']['eckType'], this._injectedDialogData['data']['bundle'], this._injectedDialogData['data']['EntityID']);
        this.setFormMode("edit");
      }

      if (this._injectedDialogData['data']['action'] == 'delete') {
        this.setFormMode("delete")
      }

      if (this._injectedDialogData['data']['action'] == 'refund') {
        // Support for refunds without loading in a payment entity.
        if (!(this._injectedDialogData?.['data']?.['EntityID'])) {
        } else {
          this.getEntity(this._injectedDialogData['data']['eckType'], this._injectedDialogData['data']['bundle'], this._injectedDialogData['data']['EntityID']);
        }

        this.setFormMode("refund");
      }

      // Special case for editing an enrollment.
      if (this._injectedDialogData['data']['action'] == 'editEnrollment') {
        this.actionType = 'edit';
        this.getEntity(this._injectedDialogData['data']['eckType'], this._injectedDialogData['data']['bundle'], this._injectedDialogData['data']['EntityID']);
        this.setFormMode(1);
      }

      // Special case for for signing an enrollment.
      if (this._injectedDialogData['data']['action'] == 'signEnrollment') {
        this.actionType = 'signEnrollment';
        this.initActionType = 'signEnrollment';
        this.getEntity(this._injectedDialogData['data']['eckType'], this._injectedDialogData['data']['bundle'], this._injectedDialogData['data']['EntityID']);
        // this.setFormMode(1);
        // this.selectFormIndex(1);
      }
      // Special case for creating an enrollment.
      if (this._injectedDialogData['data']['action'] == 'create' && this._injectedDialogData['data']['bundle'] == 'enrollment') {
        this._loadFieldsData(this.injectedDialogData?.['data']?.['fieldsData'], this.enrollmentForm);
      }
    }

    if (this.injectedDialogData?.['data']?.['fieldsData']) {
      LoggerService.log('loading fields data...', this.injectedDialogData?.['data']?.['fieldsData']);
      this._loadFieldsData(this.injectedDialogData?.['data']?.['fieldsData']);
    }
  }

  ngAfterViewInit() {
  }

  /**
   * Handle data passed from openEntityComponent here.
   *
   * Check for fields data, then patch form values if available.
   *
   * @param fieldsData
   */
  _loadFieldsData(fieldsData, formRef = null) {
    if (this.injectedDialogData?.['data']?.['fieldsData']) {
      let fieldsData = this.injectedDialogData?.['data']?.['fieldsData'];

      setTimeout(() => {
        if (!formRef) {
          this?.f?.form?.patchValue({
            ...fieldsData,
          });
        } else {
          formRef.patchValue({
            ...fieldsData,
          })
        }

      });
    }
  }

  override onSubmit(form): void {
    // Prevent multiple saves
    if (this.isSaving) {
      return;
    }
    this.isSaving = true;

    this.errorMessage = "";
    this.displayProgressSpinner(true);

    // Copy the object to not modify binded data.
    let values;
    if (this.eckType == 'packages' && this.bundle == 'package') {
      values = form.value;
    } else {
      values = _.cloneDeep(form.value);
      this.__alterValues(values);
    }

    // Check for recurring event.
    if (!this.recurringEvent) {
      values.field_repetition_units = null;
      values.field_repetition_frequency = null;
      values.field_repetition_end_date = null;
    }

    // Check for create mode.
    if (this.actionType == "create") {

      this._entityRESTService.createEntity(this.eckType, this.bundle, values)
        .subscribe(data => {
          // TODO: Respond to successful update message...
          if (this.eckType == 'packages' && this.bundle == 'enrollment') {
            this._entityRESTService.getEntity('packages', 'enrollment', data['id'][0].value)
              .subscribe(data => {
                LoggerService.log('packages enrollment data', data);
                this.entityData = data;
              });
            this._entityRESTService.getEntity('student_accounts', 'student_account', data['field_student'][0].target_id)
              .subscribe(data => {
                LoggerService.log('student_accounts student_account data');
                LoggerService.log(data);
                this.studentAccountEntityData = data;
              });
          } else {
            this.closeDialog(data);
          }

          this.displayProgressSpinner(false);
        },
          error => this.handleError(error)
        )
    }

    // Check for edit mode.
    if (this.actionType == "edit") {
      this.displayProgressSpinner(true);

      this._entityRESTService.patchEntity(this.eckType, this.bundle, this.entityId, values)
        .subscribe(data => {
          // Pass the response data to confirm save completed
          this.closeDialog({ saved: true, data: data });
          this.displayProgressSpinner(false);
        },
          error => this.handleError(error)
        )
    }

    // Check for edit mode.
    if (this.actionType == "refund") {
      this.displayProgressSpinner(true);

      this._entityRESTService.createEntity(this.eckType, this.bundle, values)
        .subscribe(data => {
          // TODO: Respond to successful update message...
          LoggerService.log('data')
          LoggerService.log(data)
          this.closeDialog(data);
          this.displayProgressSpinner(false);
        },
          error => this.handleError(error)
        )
    }
  }


  filterPhoneNumber(phoneNumber: string | any, country?: CountryCode): string {
    LoggerService.log('[filterPhoneNumber] Input:', { phoneNumber, country, type: typeof phoneNumber });

    // Handle ngx-intl-tel-input object format
    if (phoneNumber && typeof phoneNumber === 'object' && phoneNumber.e164Number) {
      LoggerService.log('[filterPhoneNumber] Object format detected, e164Number:', phoneNumber.e164Number);
      // Store in E.164 format WITH + prefix (international standard)
      return phoneNumber.e164Number;
    }

    // Handle string format (legacy or direct input)
    if (typeof phoneNumber === 'string' && phoneNumber) {
      const parsed: PhoneValidationResult = this.phoneNumberService.parseNumber(phoneNumber, country);
      LoggerService.log('[filterPhoneNumber] String format, parsed result:', parsed);
      // Return E.164 format with + prefix if successfully parsed
      const result = parsed.e164 || phoneNumber;
      LoggerService.log('[filterPhoneNumber] Returning:', result);
      return result;
    }

    LoggerService.log('[filterPhoneNumber] Returning empty string');
    return '';
  }

  __alterValues(values) {
    if (Array.isArray(values?.field_dances_type)) {
      const danceTypeAliases: Record<string, string> = {
        country: 'country western',
        country_western: 'country western',
        competition: 'competitions',
        mc_swing: 'wc swing',
      };

      values.field_dances_type = values.field_dances_type.map((value: any) => {
        if (typeof value !== 'string') {
          return value;
        }

        return danceTypeAliases[value] || value;
      });
    }

    // Alter field_package_name to just send the ID.
    if (values?.field_enrollment_package_name && values.field_enrollment_package_name != "" && /^\d+$/.test(values.field_enrollment_package_name) != true) {
      values.field_enrollment_package_name = this.regexParamID(values.field_enrollment_package_name);
    }

    // Alter student name to just send the ID.
    if (values?.field_student_name && values.field_student_name != "" && /^\d+$/.test(values.field_student_name) != true) {
      values.field_student_name = this.regexStudentName(values.field_student_name);
    }
    if (values?.field_student && typeof values.field_student != 'object' && values.field_student != "" && /^\d+$/.test(values.field_student) != true) {
      values.field_student = this.regexStudentName(values.field_student);
    }

    // Alter nested student fields to just send the ID.
    if (values?.field_students && typeof values.field_students == 'object') {
      values.field_students.forEach((value: any, index: string | number) => {
        if (values.field_students[index]?.field_student_account) {
          values.field_students[index].field_student_account = this.regexStudentName(values.field_students[index].field_student_account);
          values.field_students[index].field_students_contact = this.regexStudentName(values.field_students[index].field_students_contact);
        }
      });
    }

    // Alter nested student fields to just send the ID.
    if (values?.field_student && typeof values.field_student == 'object') {
      values.field_student.forEach((value: any, index: string | number) => {
        if (values.field_student[index]?.field_student_account) {
          values.field_student[index].field_student_account = this.regexStudentName(values.field_student[index].field_student_account);
          values.field_student[index].field_students_contact = this.regexStudentName(values.field_student[index].field_students_contact);
        }
      });
    }

    // Alter field_enrollment_package_name to just send the ID.
    if (values?.field_enrollment_package_name && values.field_enrollment_package_name != "" && /^\d+$/.test(values.field_enrollment_package_name) != true) {
      values.field_enrollment_package_name = this.regexParamID(values.field_enrollment_package_name);
    }

    // [field_student] Split out multiple attendees (support for couples) here.
    if (values?.field_student && typeof values.field_student != 'string') {
      values.field_student.forEach(function (student) {
        if (student?.field_student && student.field_student.indexOf(',') != -1) {
          LoggerService.log('Couple detected...')
          student.field_student = student.field_student.split(',')
        }
      });
    }

    // [field_student - variation] Split out multiple attendees (support for couples) here.
    if (values?.field_student && typeof values.field_student != 'string') {
      values.field_student.forEach(function (student) {
        if (student?.field_students && student.field_students.indexOf(',') != -1) {
          LoggerService.log('Couple detected...')
          student.field_students = student.field_students.split(',')
        }
      });
    }

    // [field_students] Split out multiple attendees (support for couples) here.
    if (values?.field_students && typeof values.field_students != 'string') {
      values.field_students.forEach(function (student) {
        if (student?.field_students && student.field_students.indexOf(',') != -1) {
          LoggerService.log('Couple detected...')
          student.field_students = student.field_students.split(',')
        }
      });
    }

    // Alter certain date fields to match what Drupal is looking for.
    if (values?.field_sale_date) { values.field_sale_date = moment(values.field_sale_date).format('YYYY-MM-DDTHH:mm:ss'); }
    if (values?.field_date_and_time) { values.field_date_and_time = moment(values.field_date_and_time.toString()).format('YYYY-MM-DD[\T]HH:mm:ss'); }
    if (values?.field_inquired) { values.field_inquired = moment(values.field_inquired).format('YYYY-MM-DD'); }
    if (values?.field_showed) { values.field_showed = moment(values.field_showed).format('YYYY-MM-DD'); }
    if (values?.field_booked_on) { values.field_booked_on = moment(values.field_booked_on).format('YYYY-MM-DD'); }
    if (values?.field_expiration_date) { values.field_expiration_date = moment(values.field_expiration_date).format('YYYY-MM-DD'); }
    if (values?.field_scheduled_payments) {
      values.field_scheduled_payments.forEach(function (payments) {
        if (payments?.['field_payment_date']) { payments.field_payment_date = moment(payments.field_payment_date).format('YYYY-MM-DD'); }
      });
    }

    // If any fields are blank (but not falsy values like 0 or false), set them to null.
    for (const element in values) {
      if (values[element] === undefined || values[element] === "") {
        values[element] = null;
      }
    }

    // Fix for packages when package code is blank.
    for (const element in values) {
      if (element === 'field_package_code' && values[element] === '') {
        // delete values[element];
      }
      if (element === 'use_alternating_instructor' && (values[element] === '' || values[element] === undefined || values[element] === false)) {
        delete values[element];
      }
      if (element === 'instructor_alternate_list' && (values[element] === '' || values[element] === undefined || values[element] === false)) {
        delete values[element];
      }
    }
  }

  override onDeleteSubmit(form: NgForm) {
    let values = form.value;

    let body = values;
    let type = this.eckType;
    let bundle = this.bundle;
    let id = this._injectedDialogData['data']['EntityID'];

    LoggerService.log('delete called...', id);

    this.displayProgressSpinner(true);
    this._entityRESTService.deleteEntity(type, bundle, id)
      .subscribe(data => {
        // TODO: Respond to successful delete message...
        this.closeDialog();

        // If deleting a student, redirect to student list and close all dialogs.
        if (type == 'contacts' && bundle == 'student_record') {
          this._dialog.closeAll();
          this._router.navigate(['/students-list']);
        }

        this.displayProgressSpinner(false);
      },
        error => this.handleError(error)
      );
  }

  override handleError(error: any) {
    LoggerService.log("error", error);
    this.displayProgressSpinner(false);
    this.isSaving = false; // Reset saving flag on error

    this.errorMessage = "There was an error.";

    // 400 is a rejected save (e.g. a presave validation) and 403 is a missing
    // permission. The session is still valid, so show the message and stay.
    if (error.status == 403 || error.status == 400) {
      this.errorMessage = error.error?.message || this.errorMessage;

      if (error.error?.message == "This route can only be accessed by anonymous users.") {
        // User is already logged in, forward to the dashboard.
        this._authService.set_user_authenticated(true);
        this._router.navigate(['/app/splash'], { queryParams: { logged_out_inactive: true } })
      }
    }

    // 401 means the session is gone; the user needs to log in again.
    if (error.status == 401) {
      this._authService.set_user_authenticated(false);
      this._router.navigate(['/auth/login'], { queryParams: { logged_out_inactive: true } })
    }

    if (error.status == 405) {
      this.closeDialog();
    }

    // Handle validation errors.
    if (error.status == 406) {
      let betterErrorMessage = '';
      betterErrorMessage = error.error.message.split(`\n`)
      this.errorMessage = betterErrorMessage;
    }

    // More serious error.
    if (error.status == 500) {
      this.errorMessage = error.error;
      this.closeDialog();
    }

    // Status 0 means no response came back: the request was blocked or dropped
    // on the way, or the save finished and only its reply was lost. Close as
    // before (the page behind refreshes, so they can see whether it saved),
    // but say so instead of closing silently. The snack bar stays until
    // dismissed.
    if (error.status == 0) {
      this._snackBar.open(this.noResponseMessage, 'Close');
      this.closeDialog();
    }

    // Emit the data since API doesn't give us correct validation response.
    this.emitDataChangedEvent();

    // Close the dialog
    if (this.actionType == "delete") {
      // this.closeDialog();
    }
  }

  closeDialog(data?) {
    this._dialogRef.close(data);
  }

  validateEnrollment(lessontype: any, student_account_id: string, enrollment_id: any) {
    LoggerService.log("validateEnrollment called...")

    this.enrollmentMessage = "";

    student_account_id = this._filterDigits(student_account_id);
    enrollment_id = enrollment_id;

    // All options must be selected.
    if (!lessontype || !student_account_id || !enrollment_id) { return; }

    let params = [
      { parameter: 'lessontype', value: lessontype },
      { parameter: 'studentaccountid', value: student_account_id },
      { parameter: 'enrollmentid', value: enrollment_id },
    ]
    this._drupalRESTService.httpGET('/api_rest/v1/enrollmentcheck', params)
      .subscribe(data => {
        this.enrollmentMessage = '';
        LoggerService.log(data)
        if (data['success']) {

        }
        if (data['message']) {
          // this.errorMessage = data['message'];
          this.enrollmentMessage = data['message'];
        }
      });
  }

  updateLessonDefaultTimes(lessonTypeSelected, eventType?) {
    // // If value is already set, don't continue.
    // if (this.f.form.value?.['field_duration'] != '') {
    //   return;
    // }
    let duration = '';
    switch (lessonTypeSelected) {
      case '560': // "DE"
      case '1393': // "Pre"
        duration = '00:30';
        break;
      case '600': // "Back Department"
      case '548': // "Front Department"
        duration = '00:45';
        break;
      default:
        duration = '00:45';
    }

    // All services should default to 15.
    if (eventType == 'service') {
      duration = '00:15';
    }

    if (this?.f?.form) {
      this.f.form.patchValue({
        field_duration: duration
      })
    }

    return duration;
  }

  loadLessonData(entityID: string) {
    return this._drupalRESTService.httpGET('/api_entity/eck/events/lesson/' + entityID, [{ parameter: '_format', value: 'json' }])
      .pipe(
        map((data: any) => {
          // The custom collapseEntity resource returns signature fields as a single
          // {target_id, url} object, but the template reads them as arrays (field[0].url).
          const fileFields = ['field_instructor_signature', 'field_signature_student'];
          fileFields.forEach(fieldName => {
            const val = data[fieldName];
            if (val && typeof val === 'object' && !Array.isArray(val) && val.target_id && val.url) {
              data[fieldName] = [val];
            }
          });
          return data;
        })
      );
  }

  loadEnrollmentData(entityID: string) {
    return this._drupalRESTService.httpGET('/api_entity/eck/packages/enrollment/' + entityID, [{ parameter: '_format', value: 'json' }])
      .pipe(
        map((data: any) => {
          // Transform file fields to match expected format (wrap in array for template compatibility)
          const fileFields = ['field_representative_signature', 'field_signature', 'field_parent_guardian_signature'];

          fileFields.forEach(fieldName => {
            if (data[fieldName]) {
              // If it's just a file ID (string or number), transform it
              if (typeof data[fieldName] === 'string' || typeof data[fieldName] === 'number') {
                const fileId = data[fieldName];
                // Construct the URL for private files
                data[fieldName] = [{
                  target_id: fileId,
                  url: `/system/files/private/${fileId}`
                }];
              }
              // If it's an object with target_id and url (new API format), wrap in array
              else if (data[fieldName] && typeof data[fieldName] === 'object' && !Array.isArray(data[fieldName])) {
                // Check if it has the expected structure
                if (data[fieldName].target_id && data[fieldName].url) {
                  data[fieldName] = [data[fieldName]];
                }
              }
              // If it's already an array but missing URL, add it
              else if (Array.isArray(data[fieldName]) && data[fieldName][0] && !data[fieldName][0].url) {
                const fileId = data[fieldName][0].target_id || data[fieldName][0];
                data[fieldName][0].url = `/system/files/private/${fileId}`;
              }
            }
          });

          return data;
        })
      );
  }

  recurringMode: "Days" | "Weeks" | "Months" | "yearly" | "" = "Days";
  interval: number = 1;
  field_expiration_date: string = "";
  field_recurrent_weekdays: string = "";
  valueEOM = moment().endOf('month').format('YYYY-MM-DD');
  valueEOY = moment().endOf('year').format('YYYY-MM-DD');
  valueSpecificExpirationDate

  field_recurrent_weekday_su = false;
  field_recurrent_weekday_mo = false;
  field_recurrent_weekday_tu = false;
  field_recurrent_weekday_we = false;
  field_recurrent_weekday_th = false;
  field_recurrent_weekday_fr = false;
  field_recurrent_weekday_sa = false;

  field_use_alternating_instructor = false;
  field_instructor_alternate_list = [];
  field_recurrent_month_day: string = null;

  /**
   * Check if at least one weekday is selected for weekly recurring mode
   */
  hasWeekdaySelected(): boolean {
    return this.field_recurrent_weekday_su ||
           this.field_recurrent_weekday_mo ||
           this.field_recurrent_weekday_tu ||
           this.field_recurrent_weekday_we ||
           this.field_recurrent_weekday_th ||
           this.field_recurrent_weekday_fr ||
           this.field_recurrent_weekday_sa;
  }

  /**
   * Check if standing appointment has valid configuration based on recurring mode
   */
  isStandingAppointmentValid(): boolean {
    if (!this.recurringEvent) {
      return true; // Not a recurring event, no validation needed
    }

    // Must have a stop condition
    if (!this.field_expiration_date) {
      return false;
    }

    // Weekly mode: must have at least one day selected
    if (this.recurringMode === 'Weeks' && !this.hasWeekdaySelected()) {
      return false;
    }

    // Monthly mode: must have a day selected
    if (this.recurringMode === 'Months' && !this.field_recurrent_month_day) {
      return false;
    }

    return true;
  }

  uiUpdateExpirationDate($event: { target: { value: any; }; }) {
    // LoggerService.log('$event');
    // LoggerService.log($event.target.value.format('MM/DD/YYYY'));
    this.valueSpecificExpirationDate = ($event.target.value).format('YYYY-MM-DD')
    this.field_expiration_date = ($event.target.value).format('YYYY-MM-DD')
  }

  calcDateEOM() {
    let date = moment().endOf('month').format('YYYY-MM-DD');
    this.field_expiration_date = date;
    return date;
  }

  calcDateEOY() {
    let date = moment().endOf('year').format('YYYY-MM-DD');
    this.field_expiration_date = date;
    return date;
  }

  /**
   * Clear all standing appointment values when the expansion panel is closed
   * This prevents recurring data from being sent when the user closes the panel
   */
  onStandingAppointmentPanelClosed() {
    this.recurringEvent = false;

    // Reset to default values (not clearing)
    this.recurringMode = 'Days';
    this.interval = 1;

    // Clear stop condition
    this.field_expiration_date = '';

    // Clear weekday selections
    this.field_recurrent_weekday_su = false;
    this.field_recurrent_weekday_mo = false;
    this.field_recurrent_weekday_tu = false;
    this.field_recurrent_weekday_we = false;
    this.field_recurrent_weekday_th = false;
    this.field_recurrent_weekday_fr = false;
    this.field_recurrent_weekday_sa = false;

    // Clear alternate instructor settings
    this.field_use_alternating_instructor = false;
    this.field_instructor_alternate_list = [];

    // Patch form controls with default values instead of resetting
    if (this.f?.form?.controls) {
      // Set values to defaults rather than resetting
      if (this.f.form.controls['field_repetition_units']) {
        this.f.form.controls['field_repetition_units'].setValue('Days');
      }
      if (this.f.form.controls['field_repetition_frequency']) {
        this.f.form.controls['field_repetition_frequency'].setValue(1);
      }
      if (this.f.form.controls['field_expiration_date']) {
        this.f.form.controls['field_expiration_date'].setValue('');
      }
      if (this.f.form.controls['field_recurrent_month_day']) {
        this.f.form.controls['field_recurrent_month_day'].setValue(null);
      }

      // Reset weekday checkboxes to false
      const weekdayControls = [
        'field_recurrent_weekday_su',
        'field_recurrent_weekday_mo',
        'field_recurrent_weekday_tu',
        'field_recurrent_weekday_we',
        'field_recurrent_weekday_th',
        'field_recurrent_weekday_fr',
        'field_recurrent_weekday_sa'
      ];
      weekdayControls.forEach(controlName => {
        if (this.f.form.controls[controlName]) {
          this.f.form.controls[controlName].setValue(false);
        }
      });

      // Reset alternate instructor settings
      if (this.f.form.controls['field_use_alternating_instructor']) {
        this.f.form.controls['field_use_alternating_instructor'].setValue(false);
      }
      if (this.f.form.controls['field_instructor_alternate_list']) {
        this.f.form.controls['field_instructor_alternate_list'].setValue([]);
      }
    }
  }

  openCreditCardInputComponent(component) {
    this._dialogService.openDialog(component, "fullScreenCreditCardInput", {
      data: {
        'helloWorld': "helloWorld"
      },
    }).afterClosed().subscribe(data => {
      LoggerService.log('returned cc data', data)
      this.cc_data = data;
    });
  }

  openEntityComponent(component: ComponentType<unknown>, eckType: any, bundle: any, action: any, EntityID?: any, fieldsData?: {}, callback?: () => void) {
    LoggerService.log('fieldsData', fieldsData)
    LoggerService.log('action', action)
    // Enrollment form needs the wider dialog to match the "Add Enrollment" button on the Enrollment List.
    const dialogConfig = bundle === 'enrollment' ? "enrollmentFormWithData" : "defaultWithData";
    this._dialogService.openDialog(component, dialogConfig, {
      data: {
        EntityID: EntityID,
        eckType: eckType,
        bundle: bundle,
        action: action,
        fieldsData: fieldsData ?? '',
      },
    }).afterClosed().subscribe(data => {

    });
  }

  onStudentNameSelectThenLoadSquareSavedCards($studentID: { option: { value: any; }; }) {
    LoggerService.log('onStudentNameSelectThenLoadSquareSavedCards called...', $studentID);

    this.square_payment_methods = [];
    let studentID = ($studentID?.option?.value ? $studentID.option.value : $studentID);

    // Extract the student ID from parenthesis
    let regExp = /\(([^)]+)\)(?!.*\()/;
    let matches = regExp.exec(studentID);
    if (!studentID || !matches) { return; }

    // Get the studio ID from the form or injected data
    const studioId = this._authService.selectedStudio?.id;
    if (!studioId) {
      LoggerService.error('Studio ID is required');
      return;
    }

    let endpoint = `/api/square/terminal/saved-cards/${studioId}`;
    let params = [
      { parameter: "field_student_name", value: matches[1] },
    ];

    this._drupalRESTService.httpGET(endpoint, params)
      .subscribe({
        next: (response: any) => {
          this.square_payment_methods = response.cards || [];
        },
        error: (error) => {
        }
      });
  }

  onStudentNameSelectThenLoadPaybrightSavedCards($studentID: { option: { value: any; }; }) {
    this.paybright_payment_methods = [];
    let studentID = ($studentID?.option?.value ? $studentID.option.value : $studentID);

    // Extract the student ID from parenthesis
    let regExp = /\(([^)]+)\)(?!.*\()/;
    let matches = regExp.exec(studentID);
    if (!studentID || !matches) { return; }

    const studioId = this._authService.selectedStudio?.id;
    if (!studioId) {
      return;
    }

    let endpoint = `/api/paybright/saved-cards/${studioId}`;
    let params = [
      { parameter: "field_student_name", value: matches[1] },
    ];

    this._drupalRESTService.httpGET(endpoint, params)
      .subscribe({
        next: (response: any) => {
          this.paybright_payment_methods = response.cards || [];
        },
        error: () => {
        }
      });

    // Saved bank accounts for PayBright ACH, same student and studio.
    this.paybright_bank_accounts = [];
    this._drupalRESTService.httpGET(`/api/paybright/bank-accounts/${studioId}`, params)
      .subscribe({
        next: (response: any) => {
          this.paybright_bank_accounts = response.bank_accounts || [];
        },
        error: () => {
        }
      });
  }

  onStudentNameSelectThenLoadStripePaymentMethods($studentID: { option: { value: any; }; }) {
    LoggerService.log('onStudentNameSelectThenLoadStripePaymentMethods called...', $studentID)

    this.payment_methods = [];
    let studentID = ($studentID?.option?.value ? $studentID.option.value : $studentID);
    let endpoint = "/api_rest/v1/stripe_get_payment_methods";
    // Extract the student ID from parenthesis.
    let regExp = /\(([^)]+)\)(?!.*\()/;
    let matches = regExp.exec(studentID);
    if (!studentID) { return };
    if (matches == null) { return };

    switch (this.initActionType) {
      case 'create':
        break;
      default:
        break;
    }

    let params = [
      { parameter: "field_student_name", value: matches[1] },
    ]

    this._drupalRESTService.httpGET(endpoint, params)
      .subscribe(data => {
        let results = data;

        this.payment_methods = results;
      })
  }


  enrollmentPaymentIncrement() {
    let control = this._formBuilder.group({
      'target_id': [null, Validators.required],
      'payment_amount': [0, Validators.required]
    });

    const enrollmentFormArray = this.paymentForm.get('field_enrollment_name') as FormArray;

    enrollmentFormArray.controls.forEach((group: FormGroup, index: number) => {
      if (group.dirty) {
        this.enrollmentTouched = index;
      }
    });

    if (this.enrollmentTouched !== false) {
      const touchedEnrollmentGroup = enrollmentFormArray.at(this.enrollmentTouched as number) as FormGroup;
      control.get('payment_amount').setValue(touchedEnrollmentGroup.get('payment_amount').value);
      this.enrollmentTouched = false;
    }

    enrollmentFormArray.push(control);
    this.distributeGrossTuitionEqually(this.paymentForm.get('field_gross_tuition').value);
  }

  enrollmentPaymentRemove(index: number) {
    const enrollmentFormArray = this.paymentForm.get('field_enrollment_name') as FormArray;
    enrollmentFormArray.removeAt(index);
    this.distributeGrossTuitionEqually(this.paymentForm.get('field_gross_tuition').value);
  }

  /**
 * Distributes the given gross tuition amount equally among all enrollments.
 * @param grossTuition The total gross tuition amount to distribute.
 */
  distributeGrossTuitionEqually(grossTuition: number) {
    const enrollmentPayments = this.paymentForm.get('field_enrollment_name').value || [];

    if (!Array.isArray(enrollmentPayments) || enrollmentPayments.length === 0) {
      return;
    }

    const enrollmentFormArray = this.paymentForm.get('field_enrollment_name') as FormArray;
    const numEnrollments = enrollmentFormArray.length;

    // Calculate the total touched amount (form values can be strings, so a
    // bare += would concatenate instead of add)
    let totalTouchedAmount = 0;
    const untouchedControls: AbstractControl[] = [];

    enrollmentFormArray.controls.forEach((group: FormGroup) => {
      const paymentAmountControl = group.get('payment_amount');
      if (paymentAmountControl.touched) {
        totalTouchedAmount += parseFloat(paymentAmountControl.value) || 0;
      } else {
        untouchedControls.push(paymentAmountControl);
      }
    });

    if (!untouchedControls.length) {
      return;
    }

    // Equal cent shares of the remainder; the last untouched row absorbs the
    // leftover cent(s) so the splits sum exactly to the gross amount instead
    // of showing a raw float like 171.21000000000004.
    const remainingAmount = (parseFloat(String(grossTuition)) || 0) - totalTouchedAmount;
    const share = Math.floor((remainingAmount / untouchedControls.length) * 100) / 100;

    untouchedControls.forEach((control, index) => {
      const value = index === untouchedControls.length - 1
        ? Math.round((remainingAmount - share * (untouchedControls.length - 1)) * 100) / 100
        : share;
      control.setValue(value);
    });
  }

  delete_stripe_payment_method(stripe_card_id) {
    this.displayProgressSpinner(true);
    LoggerService.log('delete_stripe_payment_method called...', stripe_card_id);

    // Extract the student ID from parenthesis.
    let regExp = /\(([^)]+)\)/;
    let matches = regExp.exec(this.paymentForm.value.field_student_name);

    let endpoint = "/api_stripe/v1/stripe_remove_payment_method";
    let body = {
      "stripe_card_id": stripe_card_id,
      "field_student_name": matches[1]
    }

    this._drupalRESTService.httpPOST(endpoint, body)
      .subscribe(data => {
        let results = data;

        // Get the updated list of payment methods.
        this.onStudentNameSelectThenLoadStripePaymentMethods(this.paymentForm.value.field_student_name);
        this.displayProgressSpinner(false);
      }, error => {
        this.handleError(error);
      })
  }

  checkIfEventPassedCurrentTime() {
    const startDateArray = this._injectedDialogData?.event?._def?.extendedProps?.eventDetails?.startDate;

    if (startDateArray) {
      this.isEventPassed = computeIsEventPassed(startDateArray.join('T'), this.studioTimezone);
      return this.isEventPassed;
    } else {
      LoggerService.log('Event data not available, unable to determine if event has passed.');
      return false;
    }
  }
}
